var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import teamService from "@irati/identity/services/teams";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
import { removeFromUserList } from "@irati/identity/apollo/query/UsersForBusiness";
import ButtonRouterLink from "@irati/ui/src/Link/ButtonLink/ButtonRouterLink";
import { AreYouSurePopUp } from "../../../components/AreYouSurePopUp/index";
import EditTeamNamePopUp from "../../../components/Teams/EditTeamNamePopUp/EditTeamNamePopUp";
import AddToTeam from "../../../components/Teams/CreateTeam/CreateTeam";
import BulkAddUsers from "../../../components/Teams/BulkAddUsersToTeam";
import TeamUserListRender from "../../../components/Teams/TeamUserList/TeamUserList";
import UserList, { INITIAL_USERLIST_VARIABLES } from "../../../components/UserList";
import TeamAdminHeader from "../../../components/AdminHeader/TeamAdminHeader";
import BackLink from "../../../components/Teams/TeamList/BackLink";
var steps = {
    VIEW_TEAM_USER_LIST: "VIEW_TEAM_USER_LIST",
    ADD_TO_TEAM: "ADD_TO_TEAM",
    BULK_ADD_TO_TEAM: "BULK_ADD_TO_TEAM"
};
var TeamUserList = /** @class */ (function (_super) {
    __extends(TeamUserList, _super);
    function TeamUserList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userList = React.createRef();
        _this.adminHeader = React.createRef();
        _this.deletePopup = React.createRef();
        _this.state = {
            total: 0,
            isEditTeamModalOpen: false,
            currentStep: steps.VIEW_TEAM_USER_LIST
        };
        _this.openEditTeamModal = function () {
            _this.setState({
                isEditTeamModalOpen: true
            });
        };
        _this.hideEditTeamModal = function () {
            _this.setState({
                isEditTeamModalOpen: false
            });
        };
        _this.handleHide = function () {
            _this.resetUserList();
            _this.setState({ currentStep: steps.VIEW_TEAM_USER_LIST });
        };
        _this.handleEditSuccess = function () {
            _this.setState({ isEditTeamModalOpen: false });
        };
        _this.openDeleteTeamPopUp = function () {
            _this.deletePopup.current.toggle();
        };
        _this.handleDelete = function () {
            var team = _this.props.team;
            teamService.delete(authentication.userTenant().uuid, team.uuid);
        };
        _this.resetUserList = function () {
            if (_this.userList.current) {
                _this.userList.current.setVariables(INITIAL_USERLIST_VARIABLES(_this.props.team.uuid));
            }
            if (_this.adminHeader.current) {
                _this.adminHeader.current.refetch();
            }
        };
        _this.removeUserFromTeam = function (variables, user) {
            removeFromUserList(variables, user);
            teamService.removeUserFromTeam(_this.props.team.uuid, user.uuid).then(function () { return _this.resetUserList(); });
        };
        _this.renderStep = function () {
            var currentStep = _this.state.currentStep;
            var team = _this.props.team;
            switch (currentStep) {
                case steps.ADD_TO_TEAM: {
                    return React.createElement(AddToTeam, { useModal: false, currentTeam: team, onHide: _this.handleHide });
                }
                case steps.BULK_ADD_TO_TEAM: {
                    return React.createElement(BulkAddUsers, { team: team, onHide: _this.handleHide, onSuccess: _this.handleEditSuccess });
                }
                default: {
                    return (React.createElement(UserList, { ref: _this.userList, teamId: _this.props.team.uuid }, function (_a) {
                        var users = _a.users, variables = _a.variables;
                        return (React.createElement(TeamUserListRender, { team: team, users: users.results, removeUserFromTeam: function (user) { return _this.removeUserFromTeam(variables, user); } }));
                    }));
                }
            }
        };
        _this.handleGoBack = function () {
            var currentStep = _this.state.currentStep;
            if (currentStep === steps.BULK_ADD_TO_TEAM || currentStep === steps.ADD_TO_TEAM) {
                _this.setState({ currentStep: steps.VIEW_TEAM_USER_LIST });
            }
            else {
                _this.props.goBack();
            }
        };
        return _this;
    }
    TeamUserList.prototype.render = function () {
        var _this = this;
        var _a = this.state, isEditTeamModalOpen = _a.isEditTeamModalOpen, currentStep = _a.currentStep;
        var _b = this.props, team = _b.team, formatMessage = _b.formatMessage;
        return (React.createElement("div", null,
            React.createElement(BackLink, { linkProps: { onClick: this.handleGoBack } }),
            currentStep === steps.VIEW_TEAM_USER_LIST && (React.createElement(React.Fragment, null,
                React.createElement(TeamAdminHeader, { ref: this.adminHeader, team: team }),
                React.createElement(Flex, { justifyContent: "flex-end", marginTop: 2, marginBottom: 2, alignItems: "center" },
                    React.createElement(Button, { destructive: true, onClick: this.openDeleteTeamPopUp, id: "admin_team_button_deleteTeam", marginRight: 2 },
                        React.createElement(FormattedMessage, { id: "admin.components.editTeamPopUp.button.deleteTeam" })),
                    React.createElement(Button, { onClick: this.openEditTeamModal, marginRight: 2 },
                        React.createElement(FormattedMessage, { id: "admin.containers.teamUserList.nameCountAndButton.editText" })),
                    React.createElement(ButtonRouterLink, { primary: true, onClick: function () { return _this.setState({ currentStep: steps.ADD_TO_TEAM }); }, id: "admin_team_button_addUser", marginRight: 2 },
                        React.createElement(FormattedMessage, { id: "admin.containers.teamUserList.nameCountAndButton.buttonText" })),
                    React.createElement(Button, { primary: true, onClick: function () { return _this.setState({ currentStep: steps.BULK_ADD_TO_TEAM }); } },
                        React.createElement(FormattedMessage, { id: "admin.components.bulkAddUsers.button" }))))),
            this.renderStep(),
            React.createElement(EditTeamNamePopUp, { show: isEditTeamModalOpen, team: team, onHide: this.hideEditTeamModal, onSuccess: this.handleEditSuccess }),
            React.createElement(AreYouSurePopUp, { ref: this.deletePopup, onSubmit: this.handleDelete, text: formatMessage({ id: "admin.components.editTeamPopUp.areYouSurePopUp.text" }, { teamname: this.props.team.public_name }), buttonText: formatMessage({ id: "admin.components.editTeamPopUp.areYouSurePopUp.buttonText" }) })));
    };
    return TeamUserList;
}(Component));
export default injectIntl(TeamUserList);
